import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  private baseurl = "";
  private apiroute = "";
  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.apiroute = '/FlexIntegration';
  }

  GetDepartments() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_Departments' });
  }
  Get_HumanResourcesAll() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_HumanResourcesAll' });
  }
  Get_EmployeePaytypeCE(id) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        method: 'Get_EmployeePaytypeCE',
        employeeid: id
      }
    );
  }
  Get_TimesheeTPaytype() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_TimesheeTPaytype' });
  }
  InsertUpdate_EmployeePaytypeCE(data) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        method: 'InsertUpdate_EmployeePaytypeCE',
        id: data.id,
        employeeid: data.employeeid,
        paytypeid: data.paytypeid,
        rate: data.rate,
        active: data.active, 
      }
    );
  }


  GetJobCode() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_EmployeeCategoryAll' });
  }

  GetSupervisor() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_EmployeeListAll' });
  }

  GetEmploymentType() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_EmployeeType' });
  }

  InsertEmployee(firstname, lastname, employeenumber, active, email, mobilephone, emergencycontact, emergenycontactnumber, address, jobcode, departmentid, employmenttypeid, supervisorid, birthday, HireDate, TerminationDate) {
    console.log('Estoy en servicio ', birthday);

    let obj = {
      method: 'Insert_Employees',
      firstname: firstname,
      lastname: lastname,
      email: email,
      phomephone: mobilephone,
      mobilephone: mobilephone,
      departmentid: departmentid,
      employmenttypeid: employmenttypeid,
      supervisorid: supervisorid,
      emergencycontact: emergencycontact,
      ehomephone: emergenycontactnumber,
      // birthday: birthday,
      empnumber: employeenumber,
      jobcode: jobcode,
      address: address,
      active: active,
      // city: city,
      id: employeenumber,
      // state: state, 
      // zip: zip,
      terminationdate:TerminationDate,
      hiredate: HireDate,
    }
    if (birthday !== '') {
      obj['birthday'] = birthday
    }
    console.log(obj);
    return this.http.post<any>(this.baseurl + this.apiroute, obj)
  }

  GetAll() {
    return this.http.post<any>(this.baseurl + this.apiroute, { method: 'Get_HumanResourcesAll' });
  }

  InsertProjectParticipantRoles(id,name, sort, description, active){
    return this.http.post<any>(this.baseurl + this.apiroute, 
    { method: 'InsertUpdate_ProjectParticipantRoles',
      id: id,
      name: name,
      sort: sort,
      description: description,
      active: active
    });
  }

  UpdateEmployee(firstname, lastname, email, active, mobilephone, emergencyContactNumber, emergencycontact, address, id, jobcode, departmentid, employmenttypeid, supervisorid, empnumber, birthdate, HireDate, TerminationDate) {
    let obj = {
      'method': 'Update_Employees',
      firstname: firstname,
      lastname: lastname,
      email: email,
      phomephone: emergencyContactNumber,
      mobilephone: mobilephone,
      emergencycontact: emergencycontact,
      address: address,
      // city: '',
      // state: '',  
      // zip: '',
      inactive: active,
      id: id,
      birthday: birthdate,
      empnumber: empnumber,
      listid: id,
      jobcode: jobcode,
      departmentid: departmentid,
      employeementtypeid: employmenttypeid,
      supervisorid: supervisorid,
      terminationdate:TerminationDate,
      hiredate: HireDate,
    }
    console.log(obj)
    return this.http.post<any>(this.baseurl + this.apiroute, obj)
  }

  //Documents

  GetProjectDocument(id) {
    return this.http.post<any>(this.baseurl + '/ProjectDocument', { projectid: id })
  }

  UpdateProjectDocument(id, name) {
    return this.http.post<any>(this.baseurl + '/ProjectDocument/InsertUpateSalesLead', { id: id, name: name })
  }

  ListDocumentType() {
    return this.http.get<any>(this.baseurl + '/ProjectDocument/TypeDocument', {});
  }




}
